import type { ChainMetadata } from '@polaris/core/models'
import { atom } from 'jotai'

export interface TokenSelectionMetadata {
  chainId: string
  denom: string
  ticker: string
  tokenImg: string
  displayName?: string
  shouldDirectlySelect?: boolean
}

interface View {
  open: boolean
  direction: 'from' | 'to' | null
}

export const tokenSelectionOpenAtom = atom<View>({
  open: false,
  direction: null,
})

export const networkSelectionOpenAtom = atom<View>({
  open: false,
  direction: null,
})

export const animatedOpenAtom = atom(false)

export const filteredNetworkAtom = atom<ChainMetadata | null>(null)

export const networkSelectionMetadataAtom =
  atom<Partial<TokenSelectionMetadata> | null>(null)

export const yourBalancesAccordionAtom = atom<'your-balances' | '' | undefined>(
  undefined,
)

export const singleBalanceAccordionAtom = atom<string>()
